import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import DaumPostcode from 'react-daum-postcode';

export default class Eventaddpopup extends Component {
  constructor(props)
  {
      super(props);
      this.state = {
          open: false,
          title: "",
			address: false,
			fullAddress1: "",
			fullAddress2: "",
			zip: ""
      };
  }
  Open(_title)
  {
    this.setState({
        open: true,
        title: _title
    });
  }
  Close()
  {
      this.setState({
          open: false
      });
  }

  handleComplete = (data) => {
    let fullAddress = data.address;
    let extraAddress = ''; 
    //console.log(data);
    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
      }
      fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
    }
	this.setState({address: false, fullAddress1: fullAddress, zip: data.zonecode})
    //console.log(fullAddress);  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  }
  submitData()
  {
    const self = this;
    let device = document.getElementById('device').value;
    let current_agency = document.getElementById('current_agency').value;
    let username = document.getElementById('username').value;
    let birthday = document.getElementById('birthday').value;
    let phone_number = document.getElementById('phone_number').value;
    let available_phone_number = document.getElementById('available_phone_number').value;
    let company_name = document.getElementById('company_name').value;
    let relationship = document.getElementById('relationship').value;
	let fullAddress1 = document.getElementById('fullAddress1').value;
	let fullAddress2 = document.getElementById('fullAddress2').value;

    if( company_name == "" )
    {
      alert('근무지를 입력해주세요.');
      return false;
    }
    if( username == "" )
    {
      alert('예약자성함을 입력해주세요.');
      return false;
    }
    if( phone_number == "" )
    {
      alert('연락 가능 번호를 입력해주세요.');
      return false;
    }

	if( fullAddress1 == "" || fullAddress2 == "" ) {
		alert('주소를 기입해주세요.');
		return false;
	}

    this.loginKey = sessionStorage.getItem('loginKey');

    $.post('https://api.tfamily.co.kr/api/mobile/reserve',{
      uk: self.loginKey,
      device: device,
      current_agency: current_agency,
      username: username,
      birthday: birthday,
      phone_number: phone_number,
      available_phone_number: available_phone_number,
      company_name: company_name,
      relationship : relationship,
		zipcode : this.state.zip,
		address0 : fullAddress1,
		address1 : fullAddress2
    },function(data){
      let pData = JSON.parse(data);
      if(pData.error_code == 200)
      {
        alert('접수 되었습니다. 감사합니다.');
        self.Close();
      } else
      {
        alert('에러가 발생하였습니다. 다시 시도해주세요');
      }
    });

  }

  render()
  {
      const self = this;
      return (

          <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
            <div className="modal-dialog modal-md mb0">
              <div className="pt10 pb10">

                <h4><b>{self.state.title}</b></h4>

                <form>
                  <div className="form-group pt15">
                    <label htmlFor="device">모델명 / 용량 / 색상 </label>
                    <input type="text" id="device" className="form-control" />
                  </div>
                  <div className="form-group pt15">
                    <label htmlFor="current_agency">현재 이용중인 통신사</label>
                    <input type="text" id="current_agency"  className="form-control" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="username">성함</label>
                    <input type="text" id="username" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="birthday">생년월일 <small>1990-01-01</small></label>
                    <input type="text" id="birthday" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone_number">휴대폰번호 </label>
                    <input type="text" id="phone_number" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="available_phone_number">연락가능번호 </label>
                    <input type="text" id="available_phone_number" className="form-control" />
                  </div>
				  <div className="form-group">
                    <label htmlFor="address">주소 </label>
					<div>
					<a className="btn btn-default" href="#address" onClick={()=>{
						self.setState({address: true})
					}}>우편번호찾기</a>
					</div>
					{self.state.address ? <DaumPostcode onComplete={self.handleComplete}/> : null}
					{self.state.fullAddress1 !== "" ? <>
						<div>
							<input tye="text" id="fullAddress1" readonly="true" value={self.state.fullAddress1} className="form-control" />
						</div>
						<div>
							<input tye="text" id="fullAddress2"  className="form-control" />
						</div>
					</> : null}
                  </div>
                  <div className="form-group pt15">
                    <label htmlFor="company_name">근무 회사명 / 직원성함</label>
                    <input type="text" id="company_name"  className="form-control" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="relationship">사전예약자와의 관계 (본인 or 가족) </label>
                    <input type="text" id="relationship" className="form-control" />
                  </div>
                  <div className="form-group pt15">
                    <label className="text-danger"><strong>예약정보 입력시 정보 미기재 또는 오기재(고객과실로 인한) 예약 누락시 당사에서 책임 및 보상 의무가 없음을 알려드립니다.</strong></label>
                  </div>
                  <div className="row text-center">
                    <a href="#submitData" onClick={()=>{self.submitData()}} className="btn btn-default">제출</a>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
        );
  }

}
